import React from 'react';
import { MoreOutlined, GlobalOutlined } from '@ant-design/icons';

interface SiteCardProps {
  name: string;
  status: 'active' | 'inactive' | 'deploying' | 'error';
  lastDeploy: string;
  type: string;
  url?: string;
  domain?: string;
}

const SiteCard: React.FC<SiteCardProps> = ({ 
  name, 
  status, 
  lastDeploy, 
  type,
  url,
  domain 
}) => {
  const statusConfig = {
    active: { color: 'bg-green-500', text: 'Active', textColor: 'text-green-700' },
    inactive: { color: 'bg-gray-500', text: 'Inactive', textColor: 'text-gray-700' },
    deploying: { color: 'bg-blue-500', text: 'Deploying', textColor: 'text-blue-700' },
    error: { color: 'bg-red-500', text: 'Error', textColor: 'text-red-700' },
  };

  const currentStatus = statusConfig[status];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-5 hover:shadow-md transition-all hover:border-gray-300 dark:hover:border-gray-600 group">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-teal-600 rounded-lg flex items-center justify-center text-white">
            <GlobalOutlined className="text-lg" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white group-hover:text-blue-600 transition-colors">
              {name}
            </h3>
            <p className="text-xs text-gray-500 dark:text-gray-400">{type}</p>
          </div>
        </div>
        
        <button className="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
          <MoreOutlined />
        </button>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-gray-100 dark:border-gray-700">
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 ${currentStatus.color} rounded-full ${status === 'deploying' ? 'animate-pulse' : ''}`}></div>
          <span className={`text-xs font-medium ${currentStatus.textColor}`}>
            {currentStatus.text}
          </span>
        </div>
        
        <span className="text-xs text-gray-500">{lastDeploy}</span>
      </div>

      {domain && (
        <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-1">Domain:</p>
          <p className="text-xs font-medium text-gray-900 dark:text-white">{domain}</p>
        </div>
      )}

      {url && (
        <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
          <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs text-blue-600 hover:text-blue-700 font-medium"
          >
            {url} →
          </a>
        </div>
      )}
    </div>
  );
};

export default SiteCard;

